import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicMailFrequencyDto extends EpimsBaseEntityDto   {
    StaffId: string;
    StaffName: string;
 
    StaffEmail: string;
    MailFrequency: number;
    FequencyType: string;
    DayMail: string;
    MailTime: string;
    CustomFrequency: string;
}